'use strict';

/**
 * @typedef MissedCustomersController
 * @property { (function()) } getMissedCustomerOrders
 */

/**
 * @param { Moment & function(): Moment} moment
 * @param modalService
 * @param FlashService
 * @return {MissedCustomersController}
 * @constructor
 */
class MissedCustomersController {
  /**
   * @param $location
   * @param moment
   * @param jobService
   * @param modalService
   * @param {FlashService} FlashService
   * @param analyticsService {AnalyticsService}
   */
  constructor($location, moment, jobService, modalService, FlashService, analyticsService) {
    // noinspection BadExpressionStatementJS
    'ngInject';

    this.$location = $location;
    this.moment = moment;
    this.modalService = modalService;
    this.flashService = FlashService;
    this.analyticsService = analyticsService;

    /**
     * @type {{value: MissedCustomer[], loading: boolean, error: boolean}}
     */
    this.result = {
      loading: true,
      value: undefined,
      error: false
    };
  }

  $onInit() {
    this.analyticsService.getMissedCustomerOrders()
      .then(value => this.result = {
        loading: false,
        value
      })
      .catch(_ => this.result = {
        loading: false,
        error: true
      });
  }

  get hasMissedCustomers() {
    return !this.result.loading && !!this.result.value && !!this.result.value.length;
  }

  get noMissedCustomers() {
    return !this.result.loading && !!this.result.value && !this.result.value.length;
  }

  showMissedCustomers() {
    this.$location.path('/customers/left');
  }
}

/**
 * @ngdoc directive
 * @name gfcmsApp.directive:gfMissedCustomers
 * @description
 * # gfJobList
 */
const MissedCustomersComponent = {
  template: `<div ng-click="$ctrl.showMissedCustomers()" class="col-lg-4 col-md-4 col-sm-12 mb"
 ng-hide="$ctrl.result.error">
    <div class="pn centered" ng-class="{'weather-4': $ctrl.noMissedCustomers, 'weather-3': $ctrl.hasMissedCustomers}">
        <i class="fa fa-calendar"></i>
        <h1 ng-show="$ctrl.noMissedCustomers">NO</h1>
        <h1 ng-show="$ctrl.hasMissedCustomers">{{$ctrl.result.value.length}}</h1>
        <h1 ng-show="$ctrl.result.loading">
            <img height="40" width="40" src="../../images/progress.gif" alt="spinner"/>
        </h1>
        <div>
            <h3 class="centered">JOBS LEFT TO SCHEDULE</h3>
            <h3 class="centered">THIS MONTH</h3>
        </div>
    </div>
</div>
<!-- /col-md-4-->`,
  restrict: 'E',
  link: function (scope, element, attrs) {
    // element.text('this is the gfMissedCustomers directive');
  },
  scope: {
    jobs: '='
  },
  controller: MissedCustomersController
};


angular.module('gfcmsApp').component('gfMissedCustomers', MissedCustomersComponent);
